export type AttachmentRole = 'context' | 'reference' | 'dependency' | 'handoff-payload';
export type AttachedType = 'artifact' | 'memory' | 'task' | 'conversation';

export interface AttachmentSummaryInput {
  attachedType: AttachedType;
  role: AttachmentRole;
}

export type AttachmentPurpose = 'generated' | 'attached' | 'referenced' | 'handoff';

export function attachmentPurpose(attachment: AttachmentSummaryInput): AttachmentPurpose {
  if (attachment.role === 'handoff-payload') return 'handoff';
  if (attachment.attachedType === 'artifact' && attachment.role === 'context') return 'generated';
  if (attachment.role === 'reference' || attachment.role === 'dependency') return 'referenced';
  return 'attached';
}

export function attachmentReason(attachment: AttachmentSummaryInput): string {
  if (attachment.role === 'handoff-payload') return 'Folded handoff result from another conversation.';
  if (attachment.role === 'dependency') return 'Required dependency for this assistant context.';
  if (attachment.role === 'reference') return 'Referenced material available to the assistant.';
  if (attachment.attachedType === 'artifact') return 'Generated or promoted output available as context.';
  return 'User-provided context for this conversation.';
}

export function canCorrectIntentDecision(input: {
  disambiguatedFromDecisionId: number | null;
  alternatives: Array<{ kind: string }>;
}): boolean {
  return input.disambiguatedFromDecisionId === null && input.alternatives.length > 0;
}
